import { IdsAttribute, IdsFilterSpec, IdsMetric, IdsNode, IdsRow, IMetricDataSetProvider } from "./PA.MetricDataSet.IF";
import { IMetricDataProviderOptions } from "./IMetricDataProviderOptions";
import { DBMetricDataSetProvider } from "./DBMetricDataSetProvider";

export class MetricDataSetProvider implements IMetricDataSetProvider {
    private createOptions: IMetricDataProviderOptions;
    private dsp: IMetricDataSetProvider;

    constructor(createOptions?: IMetricDataProviderOptions) {
        this.createOptions = createOptions;
        this.dsp = undefined;

        switch (this.createOptions.providerType) {
            case "database":
                this.dsp = new DBMetricDataSetProvider(createOptions);
                break;
        }
    }

    get bLoaded(): boolean {
        if (this.dsp) return this.dsp.bLoaded;
        return false;
    }

    OnLoadComplete(): Promise<void> {
        if (this.dsp) return this.dsp.OnLoadComplete();

        return Promise.resolve();
    }

    get Name(): string {
        if (this.dsp) return this.dsp.Name;
        return "";
    }

    getAttributeNodes(attributeId: string, ids: number[]): Promise<IdsNode[]> {
        if (this.dsp) return this.dsp.getAttributeNodes(attributeId, ids);
        return Promise.resolve([]);
    }

    getAttributes(): IdsAttribute[] {
        if (this.dsp) return this.dsp.getAttributes();
        return [];
    }

    getDataRows(
        arrAttributeIds: string[],
        arrMetricIds: string[],
        filters: IdsFilterSpec[],
        rowCountThreshold?: number,
    ): Promise<IdsRow[]> {
        if (this.dsp) return this.dsp.getDataRows(arrAttributeIds, arrMetricIds, filters, rowCountThreshold);
        return Promise.resolve([]);
    }

    getDistinctValues(attributeId: string, filters?: IdsFilterSpec[]): Promise<any[]> {
        if (this.dsp) return this.dsp.getDistinctValues(attributeId, filters);
        return Promise.resolve([]);
    }

    getMetrics(): IdsMetric[] {
        if (this.dsp) return this.dsp.getMetrics();
        return [];
    }

    getRowAttribute(row: IdsRow, attributeId: string): any {
        if (this.dsp) return this.dsp.getRowAttribute(row, attributeId);
        return undefined;
    }

    getRowMetric(row: IdsRow, metricId: string): number {
        if (this.dsp) return this.dsp.getRowMetric(row, metricId);
        return undefined;
    }

    getRowData(row: IdsRow, keyId: string): any {
        if (this.dsp) return this.dsp.getRowData(row, keyId);
        return undefined;
    }

    setRowData(row: IdsRow, keyId: string, value: any): void {
        if (this.dsp) this.dsp.setRowData(row, keyId, value);
    }

    getRowAggregateMetric(rows: IdsRow[], metricId: string): number {
        if(this.dsp)
            return this.getRowAggregateMetric(rows, metricId)
    }



    getValueRange(attributeId: string, filters?: IdsFilterSpec[]): Promise<{ min: any; max: any }> {
        if (this.dsp) return this.dsp.getValueRange(attributeId, filters);
        return Promise.resolve({ min: undefined, max: undefined });
    }
}
